import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate, useLocation } from 'react-router-dom';

const LandingRedirectHandler = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect if still loading authentication state
    if (isLoading) return;

    // Don't redirect if user is authenticated
    if (isAuthenticated) return;

    // Don't redirect if already on landing page
    if (location.pathname === '/landing') return;

    // Check if user is visiting the main URL (/) for the first time
    if (location.pathname === '/' && !location.search.includes('channel=')) {
      // Check if user has already seen the landing page in this session
      const hasSeenLanding = sessionStorage.getItem('hasSeenLanding');

      if (!hasSeenLanding) {
        navigate('/landing', { replace: true });
        return;
      }
    }

    // For all other cases, allow normal navigation
  }, [isAuthenticated, isLoading, location.pathname, navigate]);

  // Mark that user has seen landing page when they visit it
  useEffect(() => {
    if (location.pathname === '/landing') {
      sessionStorage.setItem('hasSeenLanding', 'true');
    }
  }, [location.pathname]);

  return children;
};

export default LandingRedirectHandler;
